module.exports = __webpack_public_path__ + "img/billing-notice.9e3928fa.svg";